module.exports = __webpack_public_path__ + "img/Réalisation capot alu + trappe pour local piscine.0c0cae44.jpg";